import { Button } from 'components/Button';
import { Flex } from 'components/layout';
import ButtonLoader from 'components/loading/ButtonLoader';
import { PendingEmail } from 'types/PendingOutboxEmail';
import ButtonText from 'types/enums/ButtonText';
import { ButtonNamePosthog } from 'types/enums/CustomPosthogEvents';

interface CancelAndRescheduleEmailButtonsProps {
  email: PendingEmail;
  onCancelClick: (emailId: number) => void;
  isDirty: boolean;
  loading: boolean;
}

const CancelAndRescheduleEmailButtons = ({
  email,
  onCancelClick,
  isDirty,
  loading,
}: CancelAndRescheduleEmailButtonsProps) => {
  return (
    <Flex direction='row' gap='sm' className='mt-2'>
      <Button
        buttonNamePosthog={ButtonNamePosthog.CancelCarrierEmail}
        type='button'
        onClick={(e) => {
          e.preventDefault();
          onCancelClick(email.id);
        }}
        variant='destructive'
        className='flex-1 text-xs'
        size='xs'
      >
        {ButtonText.CancelCarrierEmail}
      </Button>
      <Button
        buttonNamePosthog={ButtonNamePosthog.RescheduleCarrierEmail}
        type='submit'
        disabled={!isDirty || loading}
        className='flex-1 text-xs'
        size='xs'
      >
        {loading ? <ButtonLoader /> : ButtonText.RescheduleCarrierEmail}
      </Button>
    </Flex>
  );
};

export default CancelAndRescheduleEmailButtons;
